import { render, staticRenderFns } from "./Homenewslist.vue?vue&type=template&id=277cdcde&scoped=true&"
import script from "./Homenewslist.vue?vue&type=script&lang=js&"
export * from "./Homenewslist.vue?vue&type=script&lang=js&"
import style0 from "./Homenewslist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Homenewslist.vue?vue&type=style&index=1&id=277cdcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277cdcde",
  null
  
)

export default component.exports